import pieCharts, { type PieChartsOptions } from "@client/lib/jquery/piecharts";
import { makeWith, makeWrap } from "./factory";

export interface PieChartsProps {
  pieChartsOptions: PieChartsOptions;
}

export const withPieCharts = makeWith<PieChartsProps>(
  (element: HTMLElement, props: PieChartsProps) => pieCharts(element, props.pieChartsOptions),
  "pieChartsOptions"
);

const pieChartsTag = makeWrap<PieChartsProps>(withPieCharts);
export default pieChartsTag;
